import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Route } from 'react-router-dom'
import ThreadList from 'components/client/messages/thread-list'
import ViewProposal from 'components/client/bookings/view-proposal'
import Conversations from 'components/client/messages/conversation'

const Threads = ({ match }) => {
  const [messageData, setMessageData] = useState({ action: 'message' })
  const action = messageData.action

  const handleMessageOrProposal = (data = {}) => {
    // console.log(data)
    data.action = data.action || 'message'
    setMessageData(data)
  }

  return (
    <>
      {action === 'message' && (
        <div className="h-vh-msg flex-1 flex lg:flex-row flex-col w-full">
          <ThreadList params={match.params} />
          <Route
            path={`${match.path}/:id/conversation`}
            render={(props) => (
              <Conversations {...props} handleMessageOrProposal={handleMessageOrProposal} />
            )}
          />
        </div>
      )}
      {action === 'view-proposal' && (
        <ViewProposal
          proposalId={messageData.proposalId}
          handleClose={handleMessageOrProposal}
          closeTitle={messageData.closeTitle}
        />
      )}
    </>
  )
}

Threads.propTypes = {
  match: PropTypes.object.isRequired,
}

export default withRouter(Threads)
